import React, { Component } from 'react';
export default class Header extends Component {
  render() {
    return (
      <React.Fragment>
          <header id="home">
        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
          <a className="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>
          <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">About</a></li>
            <li><a className="smoothscroll" href="#resume">Resume</a></li>
            <li><a className="smoothscroll" href="#portfolio">Works</a></li>
            <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li>
            <li><a className="smoothscroll" href="#contact">Contact</a></li>
          </ul> {/* end #nav */}
        </nav> {/* end #nav-wrap */}
        <div className="row banner">
          <div className="banner-text">
            <h1 className="responsive-headline">I'm Rishav Kumar.</h1>
            <h3>I'm a <span>Software Developer</span>, <span>illusionist</span> and <span>Pragmatic</span> with the knack of problem solving. I believe in  simple and try creating awesome and
              effective results. I'm presently working at <span> LinkedIn as a Software Engineer.</span> Previously, I have worked with Arcesium & BrowserStack as Software Engineer.
              <br/> <a className="smoothscroll" href="#about">start scrolling </a>
               and learn more <a className="smoothscroll" href="#about">about me</a>.</h3>
            <hr />
            <ul className="social">
              <li><a href="https://www.linkedin.com/in/rishav-kumar-7162b44b"><i className="fa fa-linkedin" /></a></li>
              <li><a href="https://github.com/rishav-csenitjsr"><i className="fa fa-github" /></a></li>
              <li><a href="https://www.instagram.com/rishu_kiddy_boy/"><i className="fa fa-instagram" /></a></li>
              <li><a href="https://www.facebook.com/rishav.kumar11"><i className="fa fa-facebook" /></a></li>
              <li><a href="https://twitter.com/RishavK02874063"><i className="fa fa-twitter" /></a></li>
              {/* <li><a href="#"><i className="fa fa-google-plus" /></a></li>
              <li><a href="#"><i className="fa fa-dribbble" /></a></li>
              <li><a href="#"><i className="fa fa-skype" /></a></li> */}
            </ul>
          </div>
        </div>
        <p className="scrolldown">
          <a className="smoothscroll" href="#about"><i className="icon-down-circle" /></a>
        </p>
      </header>
      </React.Fragment>
    );
  }
}